"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var sizes = {
  m: {
    width: 17,
    height: 20
  }
};
var SuperCashBackIcon = function SuperCashBackIcon(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var style = size === 'custom' ? {} : sizes[size];
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement("svg", (0, _extends2["default"])({
      viewBox: "0 0 17 20",
      fill: "none",
      style: style
    }, rest), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0718 6.73047H7.10522C6.37293 6.73047 5.7793 7.3241 5.7793 8.05639V18.6637C5.7793 19.396 6.37293 19.9897 7.10522 19.9897H13.0718C14.9026 19.9897 16.3866 18.5056 16.3866 16.6749C16.3866 15.7496 16.0076 14.9129 15.3962 14.3116C15.3128 14.2295 15.216 14.1665 15.1111 14.1205V12.5996C15.216 12.5537 15.3128 12.4906 15.3962 12.4085C16.0076 11.8072 16.3866 10.9705 16.3866 10.0453C16.3866 8.21455 14.9026 6.73047 13.0718 6.73047Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.82592 6.42188H12.7926C14.6233 6.42188 16.1073 7.90596 16.1073 9.73667C16.1073 10.6619 15.7283 11.4986 15.1169 12.1C14.9145 12.2991 14.6332 12.3865 14.3493 12.3885H10.3536L12.3709 10.3712C12.6298 10.1123 12.6298 9.69253 12.3709 9.43363C12.112 9.17473 11.6922 9.17473 11.4333 9.43363L8.31691 12.55C8.12208 12.7449 8.07386 13.0308 8.17227 13.2707C8.20462 13.3518 8.25363 13.4278 8.3193 13.4935L11.4333 16.6075C11.6922 16.8664 12.112 16.8664 12.3709 16.6075C12.6298 16.3486 12.6298 15.9289 12.3709 15.67L10.4153 13.7144H12.461L14.3391 13.7144C14.6264 13.7144 14.9121 13.8015 15.1169 14.003C15.7283 14.6043 16.1073 15.441 16.1073 16.3663C16.1073 18.197 14.6233 19.6811 12.7926 19.6811H6.82592C6.09363 19.6811 5.5 19.0874 5.5 18.3551V7.74779C5.5 7.01551 6.09363 6.42188 6.82592 6.42188Z",
      fill: "url(#paint0_radial_872_35211)"
    }), /*#__PURE__*/_react["default"].createElement("g", {
      filter: "url(#filter0_f_872_35211)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.92507 6.7793L7.20215 8.18082L5.83201 11.32L4.40625 6.7793H9.92507Z",
      fill: "#17181A"
    })), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.01624 2.73376L7.30803 5.1365L9.70854 6.56383L7.1412 8.08385L5.95484 10.3175L5.38702 10.2755L4.32233 7.77799L1.88477 6.46188L4.18329 5.1365L5.38702 2.66504L6.01624 2.73376Z",
      fill: "white"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.78784 2.44777L5.38653 1.65674L4.98522 2.44777L3.79422 4.79537L1.62106 6.07667L0.963596 6.46431L1.62106 6.85194L3.79422 8.13324L4.98522 10.4808L5.38653 11.2719L5.78784 10.4808L6.97883 8.13324L9.15199 6.85194L9.80946 6.46431L9.15199 6.07667L6.97883 4.79537L5.78784 2.44777Z",
      fill: "url(#paint1_linear_872_35211)",
      stroke: "white",
      strokeWidth: "0.9"
    }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
      id: "filter0_f_872_35211",
      x: "3.40625",
      y: "5.7793",
      width: "7.51953",
      height: "6.54102",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/_react["default"].createElement("feFlood", {
      floodOpacity: "0",
      result: "BackgroundImageFix"
    }), /*#__PURE__*/_react["default"].createElement("feBlend", {
      mode: "normal",
      "in": "SourceGraphic",
      in2: "BackgroundImageFix",
      result: "shape"
    }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
      stdDeviation: "0.5",
      result: "effect1_foregroundBlur_872_35211"
    })), /*#__PURE__*/_react["default"].createElement("radialGradient", {
      id: "paint0_radial_872_35211",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.1185 13.0515) rotate(180) scale(10.9388 8.75106)"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#00CAC1"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "0.34375",
      stopColor: "#13B8DC"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "0.755208",
      stopColor: "#386CDE"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#693CB8"
    })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint1_linear_872_35211",
      x1: "5.38653",
      y1: "2.65137",
      x2: "5.38653",
      y2: "10.2772",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#AD43BE"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#386CDE"
    }))))
  );
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SuperCashBackIcon);